import { inRange, uniq, isNaN } from 'lodash';

const yardsInFurlong = 220;
const furlongsInMile = 8;
const forthPartOfYard = yardsInFurlong / 4;
const roundToLowerValue = forthPartOfYard;
const roundToGreaterValue = forthPartOfYard * 3;
const halfSymbol = '½';
const yardsLabel = 'yds';
const furlongsLabel = 'f';
const milesLabel = 'm';

const getShortForm = (yardsValue, furlongsValue, milesValue) => {
    const result = [];
    let resultYards = null;
    let resultFurlongs = furlongsValue;
    let resultMiles = milesValue;

    if (yardsValue > roundToLowerValue && yardsValue < roundToGreaterValue) {
        resultYards = halfSymbol;
    }
    // If yards value is rounded to greater, lets add 1 unit to furlongs value
    if (yardsValue >= roundToGreaterValue) {
        resultFurlongs += 1;
    }

    // If yards value is rounded to greater, lets add 1 unit to furlongs value
    if (resultFurlongs >= furlongsInMile) {
        resultFurlongs = 0;
        resultMiles += 1;
    }

    // Don't show 0 number
    if (!resultFurlongs) {
        resultFurlongs = '';
    }

    if (resultMiles) {
        result.push(resultMiles + milesLabel);
    }
    if (resultFurlongs || resultYards) {
        result.push(resultFurlongs + resultYards + furlongsLabel);
    }

    return result;
};

const getLongForm = (yardsValue, furlongsValue, milesValue) => {
    const result = [];
    if (milesValue) {
        result.push(milesValue + milesLabel);
    }
    if (furlongsValue) {
        result.push(furlongsValue + furlongsLabel);
    }
    if (yardsValue) {
        result.push(yardsValue + yardsLabel);
    }

    return result;
};

export const yardsToFurlongs = (yards, isShowInLongForm) => {
    if (!isFinite(yards)) {
        return '';
    }

    const yardsValue = yards % yardsInFurlong;

    // Calculate furlongs value (with no dependant on yards rounding)
    const furlongsValue = Math.floor((yards / yardsInFurlong) % furlongsInMile);

    // Calculate miles value
    const milesValue = Math.floor(yards / yardsInFurlong / furlongsInMile);

    const result = isShowInLongForm
        ? getLongForm(yardsValue, furlongsValue, milesValue)
        : getShortForm(yardsValue, furlongsValue, milesValue);

    return result.join('');
};

const furlongMap = {
    flat: [
        { from: 0, to: 1211, value: '5f' },
        { from: 1211, to: 1431, value: '6f' },
        { from: 1431, to: 1651, value: '7f' },
        { from: 1651, to: 2091, value: '1m-1m1f' },
        { from: 2091, to: 2531, value: '1m2f-1m3f' },
        { from: 2531, to: 2971, value: '1m4f-1m5f' },
        { from: 2971, to: 3411, value: '1m6f-1m7f' },
        { from: 3411, to: Infinity, value: '2m-plus' },
    ],
    jumps: [
        { from: 0, to: 3851, value: '2m-2m1f' },
        { from: 3851, to: 4291, value: '2m1½f-2m3f' },
        { from: 4291, to: 4951, value: '2m3½f-2m6f' },
        { from: 4951, to: 5831, value: '2m7f-3m2½f' },
        { from: 5831, to: Infinity, value: '3m3f-plus' },
    ],
};

export function distanceMap(yard, raceType) {
    const matchedRange = furlongMap[raceType].find(range =>
        (isNaN(yard) ? null : inRange(yard, range.from, range.to))
    );

    return matchedRange && matchedRange.value;
}

export function mapYardGroups(yardsRange, raceType) {
    return uniq(
        yardsRange
            .split('-')
            .map(yardStr => parseInt(yardStr, 10))
            .map(yard => distanceMap(yard, raceType))
            .filter(distance => distance)
    ).join('-');
}

export const formatWinDist = (raceOutcomeCode, winningDistance, distanceToWinner) => {
    if (!winningDistance && !distanceToWinner) {
        return null;
    }

    return +raceOutcomeCode === 1 ? `by ${winningDistance}, ` : `btn ${distanceToWinner}, `;
};




// WEBPACK FOOTER //
// ./src/js/utils/distance.js